import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { IdiomaGR } from "@sharedV11/classes/tarifaResponse/idiomaGR";
import { IdiomasInfoI18N } from "@sharedV11/classes/tarifaResponse/IdiomasInfoI18N";
import { InternetGroup } from "@sharedV11/classes/tarifaResponse/internetgroup";
import { AlertService } from "@sharedV11/services/alerts/alert/alert.service";
import { HttpErrorsService } from "@sharedV11/services/alerts/errors/http-errors.service";
import { SnackbarInfoService } from "@sharedV11/services/alerts/snackbar-info/snackbar-info.service";
import { ConectarApiService } from "@sharedV11/services/api/connection/conectar-api.service";
import { ApiTokenService } from "@sharedV11/services/api/token/api-token.service";
import { EditInternetGroupService } from "@sharedV11/services/components/internetGroups/edit-internet-group.service";
import { GlobalServicCentros } from "@sharedV11/services/global/global.service centros";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { Translator } from "@sharedV11/services/translator/translator.service";
import { DualListComponent } from "angular-dual-listbox";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-edit-group",
  templateUrl: "./edit-group.component.html",
  styleUrls: ["./edit-group.component.scss"],
})
export class EditGroupComponent implements OnInit, AfterViewInit {

  loading = true;
  private ngUnsubscribe = new Subject();

  @Input() pkId: string;
  @Input() mode: string;
  @Input() modificar: boolean;

  idiomaOriginal = [];
  idiomaI18NOriginal = [];

  translation: any;
  editorListaIdiomas: Array<IdiomaGR> = [];
  editorListaInfo: Array<IdiomasInfoI18N> = [];
  idiomasApp: Array<IdiomaGR> = [];
  editInternetGroupForm: FormGroup;

  internetgroup: InternetGroup;
  TiposReservas: any[] = [];
  EnlacesMenu: any[] = [];

  //https://www.npmjs.com/package/angular-dual-listbox
  filter = true;
  format = {
    add: "Añadir",
    remove: "Borrar",
    all: "Todos",
    none: "Ninguno",
    direction: DualListComponent.LTR,
    draggable: true,
    locale: "es",
  };

  enlacesOriginales = [];
  source = [];
  confirmados = [];

  conectionId;
  cplist = [];

  //centros
  centrosSinAsignar = [];
  centrosAsignados = [];
  tipoCentros: any[] = [];
  //centros

  
  seosOriginales = [];
  seosSinAsignar = [];
  seosAsignados = [];
  selectedFiles: File[] = [];

  // imagenes
  imagenPortada: any;
  sizePortada: string;
  imagenFicha: any;
  sizeFicha: string;
  imagenPdf: any;
  sizePdf: string;

  imagenPortadaOriginal: any;
  imagenFichaOriginal: any;
  imagenPdfOriginal: any;

  EIMAGES = {
    PORTADA: 'portada',
    FICHA: 'ficha',
    PDF: 'pdf'  
  }

  constructor(
    private editInternetGroupService: EditInternetGroupService,
    private servicioAPI: ConectarApiService,
    private fb: FormBuilder,
    private translator: Translator,
    private cdRef: ChangeDetectorRef,
    private panelService: PanelService,
    private tokenService: ApiTokenService,
    private alertaService: AlertService,
    private httpErrorService: HttpErrorsService,
    private gsCentros: GlobalServicCentros,
    private snackvar_service: SnackbarInfoService,
  ) {}

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit(): void {
    this.loadCentros();
    this.getEnlacesMenu();
    this.getSeos();
    this.initializeTranslate();
    this.getTipoReserva();

    this.format = {
      add: this.translation.Anadir,
      remove: this.translation.Borrar,
      all: this.translation.Todos,
      none: this.translation.Ninguno,
      direction: DualListComponent.LTR,
      draggable: true,
      locale: "es",
    };

    this.initializeFormWithoutData();
  }

  ngAfterViewInit() {
    // this.pkId="4"
    this.manageForm(this.pkId, this.mode);
  }

  async loadCentros() {
    await this.gsCentros.getCentros();
  }

  async initializeTranslate() {
    this.translation = this.translator.GetTranslations();
  }

  get formControls() {
    return this.editInternetGroupForm.controls;
  }

  ver() {}
  manageForm(pkId, mode) {
    if (mode == "I") {
      this.internetgroup = this.editInternetGroupForm.value;
      this.centrosSinAsignar = this.gsCentros.filtrarTiposCentros();
      this.loading = false;
      this.getEnlacesMenu();
      
      this.getIdiomas([], []);
      this.cdRef.detectChanges();
      this.valuedChanged();
    }
    if (pkId != null) {
      this.findinternetGroup(pkId);
    }
  }

  findinternetGroup(pkId) {
    let ClaveEmpresa = this.tokenService.getConfig("chClaveEmpresa");
    let ProyectoOnLine = this.tokenService.getConfig("chProyectoOnLine");
    let ConexionEntorno = this.tokenService.getConfig("chEntornoConexion");
    this.editInternetGroupService
      .findIternetGroupByPkId(
        pkId,
        ClaveEmpresa,
        ProyectoOnLine,
        ConexionEntorno
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (userApi) => {

          let internetgroupdata: InternetGroup = userApi.DatosResult.listaGrupoInternet[0];

          if (internetgroupdata != null) {

            this.changeValueForm(internetgroupdata);
            this.internetgroup = this.editInternetGroupForm.value;
            this.internetgroup = internetgroupdata;
            this.centrosSinAsignar = this.gsCentros.filtrarTiposCentros();
            this.centrosAsignados = this.gsCentros.daTiposCentros(this.internetgroup);

            const seoOriginals = this.seosSinAsignar;
            this.seosAsignados = [];
            if (internetgroupdata.SEOIds.length > 0)
              this.seosAsignados = internetgroupdata.SEOIds.split(",").map(id => {
                return seoOriginals.find(s => s.pkId === +id);
              });

            this.source = internetgroupdata.LstEnlacesMenu;
            this.confirmados = internetgroupdata.LstEnlacesMenu.filter(
              (f) => f.Asignado == "1"
            );
            if (this.confirmados.length > 0) {
              this.conectionId = this.confirmados[0].ConexionId;
            }

            this.cdRef.detectChanges();

            this.getIdiomas(internetgroupdata.Idiomas, internetgroupdata.IdiomasInfoI18N);
            this.getListaEnlaces();

            //imagenes
            this.loadImage(internetgroupdata.Imagen, this.EIMAGES.PORTADA);
            this.loadImage(internetgroupdata.ImagenDetalle, this.EIMAGES.FICHA);
            this.loadImage(internetgroupdata.ImagenPDF, this.EIMAGES.PDF);

            this.loading = false;
          }
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
  }

  loadEntity(internetgroupdata: InternetGroup) {

      // let internetgroupdata: InternetGroup = this.internetgroup;

      this.centrosSinAsignar = this.gsCentros.filtrarTiposCentros();
      this.centrosAsignados = this.gsCentros.daTiposCentros(this.internetgroup);

      const seoOriginals = this.seosSinAsignar;
      this.seosAsignados = [];
      if (internetgroupdata.SEOIds && internetgroupdata.SEOIds.length > 0)
        this.seosAsignados = internetgroupdata.SEOIds.split(",").map(id => {
          return seoOriginals.find(s => s.pkId === +id);
        });

      if (internetgroupdata.LstEnlacesMenu) {
        this.source = internetgroupdata.LstEnlacesMenu;
        this.enlacesOriginales = this.source;
      }
      else
        this.source = this.enlacesOriginales;

      this.confirmados = this.source.filter(
        (f) => f.Asignado == "1"
      );
      if (this.confirmados.length > 0) {
        this.conectionId = this.confirmados[0].ConexionId;
      }

      if (internetgroupdata.Idiomas)
      {
        this.idiomaOriginal = internetgroupdata.Idiomas;
        this.idiomaI18NOriginal = internetgroupdata.IdiomasInfoI18N;
      }

      this.getIdiomas(this.idiomaOriginal, this.idiomaI18NOriginal);
      this.getListaEnlaces();

      if (internetgroupdata.Imagen)
        this.imagenPortadaOriginal = internetgroupdata.Imagen;

      if (internetgroupdata.ImagenDetalle)
        this.imagenFichaOriginal = internetgroupdata.ImagenDetalle;

      if (internetgroupdata.ImagenDetalle)
        this.imagenPdfOriginal = internetgroupdata.ImagenPDF;

      //imagenes
      this.loadImage(this.imagenPortadaOriginal, this.EIMAGES.PORTADA);
      this.loadImage(this.imagenFichaOriginal, this.EIMAGES.FICHA);
      this.loadImage(this.imagenPdfOriginal, this.EIMAGES.PDF);

      this.cdRef.detectChanges();

  }

  funcionEncript(json) {
    const clavePrivada = "3ñdlfjdfksdffffs%i2343424kjfdsü&/@#$A·";
    let final = "";
    for (let index = 1; index <= json.length; index++) {
      const tokenMio = this.Mid(json, index, 1);
      const codigo = this.Mid(
        clavePrivada,
        ((index - 1) % clavePrivada.length) + 1,
        1
      );
      // tslint:disable-next-line:no-bitwise
      const a = (this.Asc(codigo) ^ this.Asc(tokenMio)).toString(16);
      final = final + this.Right("0" + a, 2);
    }
    return final;
  }

  Mid(strMid, intBeg, intEnd) {
    if (strMid === null || strMid === "" || intBeg < 0) {
      return "";
    }
    intBeg -= 1;
    if (intEnd === null || intEnd === "") {
      return strMid.substr(intBeg);
    } else {
      return strMid.substr(intBeg, intEnd);
    }
  }

  Chr(num) {
    const res = String.fromCharCode(num);
    return res;
  }

  Asc(str) {
    return str.charCodeAt(0);
  }

  Right(str, n) {
    if (n <= 0) {
      return "";
    } else if (n > String(str).length) {
      return str;
    } else {
      const iLen = String(str).length;
      return String(str).substring(iLen, iLen - n);
    }
  }

  initializeFormWithData(ig: InternetGroup) {
    this.editInternetGroupForm = this.fb.group({
      pkId: [ig.pkId],
      Nombre: [ig.Nombre],
      Idioma: [ig.Idioma],
      Maximo: [ig.Maximo],
      Minimo: [ig.Minimo],
      TipoReservaId: [ig.TipoReservaId],
      ValidarGratuitas: [ig.ValidarGratuitas],
      Orden: [ig.Orden],
      Descripcion: [ig.Descripcion],
      Relevante: [""],
      // Imagen: [ig.Imagen],
      // ImageDetalle: [ig.ImageDetalle],
      ///images
      // Imagen: [ig.Imagen],
      // ImageDetalle: [ig.ImagenDetalle],
      // ImagenPDF: [ig.ImagenPDF],
    });
  }

  changeValueForm(ig: InternetGroup) {
    this.formControls["pkId"].setValue(ig.pkId);
    this.formControls["Nombre"].setValue(ig.Nombre);
    this.formControls["Idioma"].setValue(ig.Idioma);
    this.formControls["Maximo"].setValue(ig.Maximo);
    this.formControls["Minimo"].setValue(ig.Minimo);
    this.formControls["TipoReservaId"].setValue(ig.TipoReservaId);
    this.formControls["ValidarGratuitas"].setValue(ig.ValidarGratuitas);
    this.formControls["Orden"].setValue(ig.Orden);
    this.formControls["Descripcion"].setValue(ig.Descripcion);
    //this.formControls["Prefijo"].setValue(ig.Prefijo)
    this.formControls["Relevante"].setValue(ig.Relevante);
    // this.formControls["Imagen"].setValue(ig.Imagen);
    // this.formControls["ImageDetalle"].setValue(ig.ImageDetalle);
    // this.formControls["ImagenPDF"].setValue(ig.ImagenPDF);

    // this.formControls["Imagen"].setValue(ig.Imagen);
    // this.formControls["ImageDetalle"].setValue(ig.ImagenDetalle);
    // this.formControls["ImagenPDF"].setValue(ig.ImagenPDF);

    this.loadEntity(ig);
  }

  initializeFormWithoutData() {
    this.editInternetGroupForm = this.fb.group({
      pkId: [""],
      Nombre: ["", Validators.required],
      Idioma: [""],
      Descripcion: [""],
      Orden: [""],
      Maximo: [""],
      Minimo: [""],
      TipoReservaId: ["", Validators.required],
      ValidarGratuitas: [""],
      CentrosIds: [""],
      // Prefijo:[""]
      Relevante: [""],
    });
  }

  stringToBoolean(value) {
    if (typeof value !== "boolean") {
      if (value.toLowerCase() == "true") {
        value = true;
      } else {
        value = false;
      }
    }
    return value;
  }

  getTipoReserva() {
    this.servicioAPI.getTiposReserva().subscribe(
      (TiposReservas) => {
        this.TiposReservas = TiposReservas.DatosResult.listaTipoReserva;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );
  }

  getSeos() {
    const that = this;
    this.servicioAPI.getSchemas(null,null).subscribe(
      (response) => {
        const schemas = response.datosResult.listado.map((item) => ({
          pkId: item.pkId,
          Nombre: item.nombre,
        }));
        that.seosSinAsignar = schemas;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );
  }

  getEnlacesMenu() {
    this.servicioAPI.getEnlacesMenu().subscribe(
      (EnlacesMenu) => {
        this.enlacesOriginales = EnlacesMenu.DatosResult.LstEnlacesMenu;
        this.source = this.enlacesOriginales;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );
  }

  getListaEnlaces() {
    this.confirmados.forEach((c) => {
      var cplistlang = [];
      c.ListUrlVentaOnline.forEach((l) => {
        cplistlang.push({
          idioma: l.idoma,
          urlparams: "",
          url: l.UrlVentaOnline,
          grupo: this.translation.Copiar + " " + c["Nombre"],
        });
      });
      this.cplist.push(cplistlang);
    });
  }

  getIdiomas(idiomasgrupo, idiomasInfoI18N) {

    // this.editorListaInfo = [];

    this.servicioAPI.getIdiomas().subscribe(
      (losidiomas) => {

        losidiomas.DatosResult.ListaIdiomas.map((idioma) => {
          let idiomaselect = new IdiomaGR();
          idiomaselect.CodIdioma = idioma.CodIdioma;
          idiomaselect.Nombre = idioma.Nombre;
          this.idiomasApp.push(idiomaselect);

          let idiomaObj = idiomasgrupo.find(
            (i) => i.CodIdioma == idioma.CodIdioma
          );

          this.editorListaIdiomas.push(idioma);

          this.editInternetGroupForm.addControl(
            "nombre" + idioma.CodIdioma,
            new FormControl(idiomaObj ? idiomaObj.Nombre : "")
          );
          this.editInternetGroupForm.addControl(
            "descripcion" + idioma.CodIdioma,
            new FormControl(idiomaObj ? idiomaObj.Descripcion : "")
          );
          this.editInternetGroupForm.addControl(
            "descripcion1" + idioma.CodIdioma,
            new FormControl(idiomaObj ? idiomaObj.Descripcion1 : "")
          );
          this.editInternetGroupForm.addControl(
            "descripcion2" + idioma.CodIdioma,
            new FormControl(idiomaObj ? idiomaObj.Descripcion2 : "")
          );
          // this.editInternetGroupForm.addControl(
          //   "nombre" + idioma.CodIdioma,
          //   new FormControl(idiomaObj ? idiomaObj.Nombre : "")
          // );
          // this.editInternetGroupForm.addControl(
          //   "descripcion" + idioma.CodIdioma,
          //   new FormControl(idiomaObj ? idiomaObj.Descripcion : "")
          // );
          // this.editInternetGroupForm.addControl(
          //   "descripcion1" + idioma.CodIdioma,
          //   new FormControl(idiomaObj ? idiomaObj.Descripcion1 : "")
          // );
          // this.editInternetGroupForm.addControl(
          //   "descripcion2" + idioma.CodIdioma,
          //   new FormControl(idiomaObj ? idiomaObj.Descripcion2 : "")
          // );

          this.addNewControl("nombre", idioma.CodIdioma, idiomaObj, "Nombre");
          this.addNewControl("descripcion", idioma.CodIdioma, idiomaObj, "Descripcion");
          this.addNewControl("descripcion1", idioma.CodIdioma, idiomaObj, "Descripcion1");
          this.addNewControl("descripcion2", idioma.CodIdioma, idiomaObj, "Descripcion2");


          //informacion venta online

          let idiomaObjInfo = idiomasInfoI18N.find((i) => i.CodIdioma == idioma.CodIdioma);

          let idiomaInfo = new IdiomasInfoI18N();
          idiomaInfo.CodIdioma = idioma.CodIdioma;
          idiomaInfo.Nombre = idioma.Nombre;
          idiomaInfo.Titulo = idiomaObjInfo ? idiomaObjInfo.Titulo : "";
          idiomaInfo.Parrafo1 = idiomaObjInfo ? idiomaObjInfo.Parrafo1 : "";
          idiomaInfo.Parrafo2 = idiomaObjInfo ? idiomaObjInfo.Parrafo2 : "";
          // idiomaInfo.Parrafo3 = idiomaObjInfo ? idiomaObjInfo.Parrafo3 : "";
          idiomaInfo.Horario1 = idiomaObjInfo ? idiomaObjInfo.Horario1 : "";
          idiomaInfo.Horario2 = idiomaObjInfo ? idiomaObjInfo.Horario2 : "";
          idiomaInfo.Horario3 = idiomaObjInfo ? idiomaObjInfo.Horario3 : "";
          idiomaInfo.Horario4 = idiomaObjInfo ? idiomaObjInfo.Horario4 : "";
          idiomaInfo.MetaDescription = idiomaObjInfo ? idiomaObjInfo.MetaDescription : "";
          idiomaInfo.Copyright = idiomaObjInfo ? idiomaObjInfo.CopyRight : "";
          idiomaInfo.TextoAmigable = idiomaObjInfo ? idiomaObjInfo.TextoAmigable : "";
          idiomaInfo.Ubicacion = idiomaObjInfo ? idiomaObjInfo.Ubicacion : "";
          idiomaInfo.URLExterna = idiomaObjInfo ? idiomaObjInfo.UrlExterna : "";
          this.editorListaInfo.push(idiomaInfo);

          this.addNewControl("titulo", idioma.CodIdioma, idiomaObjInfo, "Titulo");
          this.addNewControl("parrafo1", idioma.CodIdioma, idiomaObjInfo, "Parrafo1");
          this.addNewControl("parrafo2", idioma.CodIdioma, idiomaObjInfo, "Parrafo2");
          // this.addNewControl("parrafo3", idioma.CodIdioma, idiomaObjInfo, "Parrafo3");
          this.addNewControl("horario1", idioma.CodIdioma, idiomaObjInfo, "Horario1");
          this.addNewControl("horario2", idioma.CodIdioma, idiomaObjInfo, "Horario2");
          this.addNewControl("horario3", idioma.CodIdioma, idiomaObjInfo, "Horario3");
          this.addNewControl("horario4", idioma.CodIdioma, idiomaObjInfo, "Horario4");
          this.addNewControl("metaDescription", idioma.CodIdioma, idiomaObjInfo, "MetaDescription");
          this.addNewControl("copyright", idioma.CodIdioma, idiomaObjInfo, "Copyright");
          this.addNewControl("textoAmigable", idioma.CodIdioma, idiomaObjInfo, "TextoAmigable");
          this.addNewControl("ubicacion", idioma.CodIdioma, idiomaObjInfo, "Ubicacion");
          this.addNewControl("urlexterna", idioma.CodIdioma, idiomaObjInfo, "URLExterna");      
          
        });

        this.internetgroup = this.editInternetGroupForm.value;
        this.valuedChanged();
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );
  }

  addNewControl(ctrName: string, idioma: string, idiomaObjInfo: IdiomasInfoI18N, field:string) {
    this.editInternetGroupForm.addControl(ctrName + idioma, new FormControl(idiomaObjInfo ? idiomaObjInfo[field] : ""));
    let control = ctrName + idioma;
    let values = idiomaObjInfo ? idiomaObjInfo[field]: "";

    // agregamos un control nuevo al form
    this.editInternetGroupForm.addControl(control, new FormControl(values));

    // por si es un update patcheamos
    if (this.editInternetGroupForm.get(control)) {
      const obj = {};
      obj[control] = values;
      this.editInternetGroupForm.patchValue(obj);
    }
  }

  submit() {

    this.editInternetGroupForm.markAllAsTouched();
    let internetgroup: InternetGroup = this.editInternetGroupForm.value;


    internetgroup.Idiomas = [];
    internetgroup.IdiomasInfoI18N = [];
    this.editorListaIdiomas.forEach((i) => {
      let enIdioma: IdiomaGR = new IdiomaGR();
      enIdioma.CodIdioma = i.CodIdioma;
      enIdioma.Nombre = internetgroup["nombre" + i.CodIdioma];
      enIdioma.Descripcion = internetgroup["descripcion" + i.CodIdioma];
      enIdioma.Descripcion1 = internetgroup["descripcion1" + i.CodIdioma];
      enIdioma.Descripcion2 = internetgroup["descripcion2" + i.CodIdioma];
      internetgroup.Idiomas.push(enIdioma);

      ///adicional
      let enInfoVO: IdiomasInfoI18N = new IdiomasInfoI18N();
      enInfoVO.CodIdioma = i.CodIdioma;
      enInfoVO.Titulo = internetgroup["titulo" + i.CodIdioma];
      enInfoVO.Parrafo1 = internetgroup["parrafo1" + i.CodIdioma];
      enInfoVO.Parrafo2 = internetgroup["parrafo2" + i.CodIdioma];
      enInfoVO.Copyright = internetgroup["copyRight" + i.CodIdioma];
      enInfoVO.Horario1 = internetgroup["horario1" + i.CodIdioma];
      enInfoVO.Horario2 = internetgroup["horario2" + i.CodIdioma];
      enInfoVO.Horario3 = internetgroup["horario3" + i.CodIdioma];
      enInfoVO.Horario4 = internetgroup["horario4" + i.CodIdioma];
      enInfoVO.MetaDescription = internetgroup["metaDescription" + i.CodIdioma];
      enInfoVO.TextoAmigable = internetgroup["textoAmigable" + i.CodIdioma];
      // enInfoVO.Tipo = internetgroup["Tipo" + i.CodIdioma];
      // enInfoVO.TipoPublico = internetgroup["TipoPublico" + i.CodIdioma];
      enInfoVO.URLExterna = internetgroup["urlexterna" + i.CodIdioma];
      enInfoVO.Ubicacion = internetgroup["ubicacion" + i.CodIdioma];
      internetgroup.IdiomasInfoI18N.push(enInfoVO);
    });

    let enlacesmenu = [];
    if (this.confirmados.length == 0) {
      enlacesmenu.push({ pkId: "", ConexionId: this.conectionId });
    }
    this.confirmados.forEach((c) => {
      enlacesmenu.push({ pkId: c.pkId, ConexionId: c.ConexionId });
    });
    //imagenes
    internetgroup.Imagen = this.imagenPortada;
    internetgroup.ImagenDetalle = this.imagenFicha;
    internetgroup.ImagenPDF = this.imagenPdf;
    // internetgroup.Imagen = this.imagenPortada;
    // internetgroup.ImagenDetalle = this.imagenFicha;
    // internetgroup.ImagenPDF = this.imagenPdf;

    internetgroup.EnlacesMenu = enlacesmenu;

    // agregados
    internetgroup.CentrosIds = this.gsCentros.obtenercentrosAsociadosconOrden(
      this.centrosAsignados
    );
    if (this.seosAsignados.length > 0)
      internetgroup.SEOIds = this.seosAsignados.map(s => s.pkId).join(",");

    internetgroup.Imagen = this.imagenPortada &&  this.imagenPortada.length > 0 ? this.imagenPortada : null;
    internetgroup.ImagenDetalle = this.imagenFicha && this.imagenFicha.length > 0 ? this.imagenFicha : null;
    internetgroup.ImagenPDF = this.imagenPdf &&  this.imagenPdf.length > 0 ? this.imagenPdf : null;

    internetgroup.Relevante = internetgroup["Relevante"] ? 1 : 0;

    this.manageApi(internetgroup, this.mode);
    //this.editRegistroForm.markAllAsTouched();
    
    if (this.editInternetGroupForm.valid) {
      this.manageApi(internetgroup, this.mode);
    }
  }

  destroy() {
    this.panelService.setDiscardChanges(true);
    this.panelService.setClosePanel(null);
  }

  save() {
    this.loading = false;
    this.panelService.setSavePanel(null);
  }
  discard() {
    this.changeValueForm(this.internetgroup);
  }

  manageApi(internetgroup: InternetGroup, mode) {
    this.loading = true;
    // internetgroup.CentrosIds = this.gsCentros.obtenercentrosAsociadosconOrden(
    //   this.centrosAsignados
    // );
    // if (this.seosAsignados.length > 0)
    //   internetgroup.SEOIds = this.seosAsignados.map(s => s.pkId).join(",");

    // internetgroup.Imagen = this.imagenPortada &&  this.imagenPortada.length > 0 ? this.imagenPortada : null;
    // internetgroup.ImageDetalle = this.imagenFicha && this.imagenFicha.length > 0 ? this.imagenFicha : null;
    // internetgroup.ImagenPDF = this.imagenPdf &&  this.imagenPdf.length > 0 ? this.imagenPdf : null;

    this.insertDataInObj();
    switch (mode) {
      case "I":
        internetgroup.pkId = "0";
        this.InsGrupoInternet(internetgroup);
        break;
      case "U":
        this.UpdGrupoInternet(internetgroup);
        break;
      case "D":
        internetgroup.pkId = "0";
        this.InsGrupoInternet(internetgroup);
        break;
      default:
        break;
    }
  }

  UpdGrupoInternet(internetgroup) {
    this.editInternetGroupService
      .updGruposInternet(internetgroup, "U")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          if (response.DatosResult != null) {
            this.save();
            this.alertaService.success("Datos Guardados Correctamente");
            this.destroy();
          } else {
            this.alertaService.error(response.Mensajes[0].DescripcionMensaje);
            //this.destroy();
          }
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
  }

  InsGrupoInternet(internetgroup) {
    this.editInternetGroupService
      .insGruposInternet(internetgroup, "I")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          if (response.DatosResult != null) {
            this.save();
            this.alertaService.success("Datos Guardados Correctamente")
            this.destroy();
          } else {
            this.loading = false;
            // this.alertaService.error(response.Mensajes[0].DescripcionMensaje);
            this.snackvar_service.openSnackBar(response.Mensajes[0].DescripcionMensaje, '', 'red-snackbar');
            // this.destroy();
          }
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
  }

  cambiaNombre(evento, idioma) {
    this.editorListaIdiomas.find((x) => x.CodIdioma == idioma).Nombre = evento;
    //
  }
  cambiaDescripcion(evento, idioma) {
    this.editorListaIdiomas.find((x) => x.CodIdioma == idioma).Descripcion =
      evento;
    //
  }

  valuedChanged() {
    this.editInternetGroupForm.valueChanges.subscribe((value) => {
      if (this.internetgroup != null) {
        this.panelService.setDiscardChanges(false);
        if (JSON.stringify(value) === JSON.stringify(this.internetgroup)) {
          this.panelService.setDiscardChanges(true);
        }
      }
    });
  }

  insertDataInForm() {
    if (<HTMLInputElement>document.getElementById("TipoReservaId-hidden"))
      this.editInternetGroupForm
        .get("TipoReservaId")
        .setValue(
          (<HTMLInputElement>document.getElementById("TipoReservaId-hidden"))
            .value
        );
  }
  insertDataInObj() {
    this.internetgroup.TipoReservaId = (<HTMLInputElement>(
      document.getElementById("TipoReservaId-hidden")
    )).value;
  }
  closeInputFilter(enventValues) {
    this.insertDataInForm();
  }
  onFileSelected(event: any, filename : string) {
    //console.log(event, filename);
    //this.selectedFiles = Array.from(event.target.files);
    
    //Show image preview
    let reader = new FileReader();
    reader.onload = (event: any) => {
      this.loadImage(event.target.result, filename);
    }
    reader.readAsDataURL(event.target.files[0]);

  }

  loadImage(source : any, filename : string){

    // no tnemos imagen
    if (source) {

      const img = new Image();
      img.src = source;
      img.onload = () => {
        this.setImageAndSize(source, filename, img.width + "x" + img.height)
      }

    } else
      this.setImageAndSize("", filename, "")

  }

  setImageAndSize(source : any, filename : string, size: string ) {

    switch(filename){
      case this.EIMAGES.PORTADA: 
        this.sizePortada = size;
        this.imagenPortada = source; 
        break;
      case this.EIMAGES.FICHA: 
        this.sizeFicha = size; 
        this.imagenFicha = source;
        break;
      case this.EIMAGES.PDF: 
        this.sizePdf = size; 
        this.imagenPdf = source;
        break;
    }

  }


}
